export default "__VITE_ASSET__o99QrDSC__"